const actionType = {
  SET_TOKEN: "SET_TOKEN",
  GET_CATEGORIES: "GET_CATEGORIES",
  SET_USER_DATA:"SET_USER_DATA"
  // SET_CATEGORIES: "SET_CATEGORIES",
};
export default actionType;
